import {Injectable} from "@angular/core";
import { ActivatedRoute, Router } from '@angular/router';
import { FilterFormService } from '../views/filter_form/filter_form.service';
import { FilterParams } from '../models/filter_form.model';
import * as qs from 'clever-qs';
import * as dictionary from "../../dict/static.json";

const config: any = dictionary['config'];

@Injectable()
export class RouteProvider {
	constructor(
		public filter: FilterFormService,
		public router: Router,
		public activatedRoute: ActivatedRoute,
	) {
		
	}
	
	async navigate(fp: FilterParams, routePath: string = '') {
		const me = this;
		
		let path = '';
		if (routePath) {
			path = `/${routePath}`;
		} else {
			path = me.router.url.split('?')[0];
		}
		
		const params = qs.stringify(fp, { encode: false });
		
		return me.router.navigateByUrl(
			`${path}?${params}`,
			{
				relativeTo: this.activatedRoute
			}
		);
	}
}
